import { AxiosError } from 'axios'
import { isArray } from 'lodash'

type SetErrorType = (name: any, error: any) => void

// TODO: maybe turn recursive to handle generic nesting.
export const setApiErrors = (setError: SetErrorType, error: AxiosError) => {
  if (error.response && error.response.data && typeof error.response.data === 'object') {
    const data = error.response.data
    for (const field in data) {
      if (isArray(data[field])) {
        for (let i = 0; i < data[field].length; i++) {
          const obj = data[field][i]
          for (const sub in obj) {
            setError(`${field}[${i}].${sub}`, obj[sub])
          }
        }
      } else {
        setError(field, data[field])
      }
    }
  }
}
